import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=1e8d1c5c&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&lang=less&"
import style1 from "./slider.vue?vue&type=style&index=1&id=1e8d1c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8d1c5c",
  null
  
)

export default component.exports